import script from "./dashboard-surveycard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-surveycard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-surveycard.vue?vue&type=style&index=0&id=4b491a41&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b491a41"]])

export default __exports__